import { jsx as _jsx } from "react/jsx-runtime";
// Constants
import { INPUT_TOOLTIP_ICON_PROPS, INPUT_TOOLTIP_PROPS } from './constants/input-tooltip.constants';
// Components
import { IconComponent } from '../../../../components/icon/icon.component';
import { TooltipComponent } from '../../../../components/tooltip/tooltip.component';
// Styles
import { InputTooltipComponentStyled } from './input-tooltip.component.styled';
const InputTooltipComponent = ({ title, tooltip, closeIcon, }) => tooltip ? (_jsx(InputTooltipComponentStyled, { children: _jsx(TooltipComponent, { ...INPUT_TOOLTIP_PROPS, closeIcon, title, content: { content: tooltip }, children: _jsx(IconComponent, { ...INPUT_TOOLTIP_ICON_PROPS }) }) })) : undefined;
export { InputTooltipComponent };
//# sourceMappingURL=input-tooltip.component.js.map